<template>
  <div>
    <a-tabs :active-key="activeKey" @change="changeTab">
      <a-tab-pane
        v-for="item in tabs"
        :key="item.routeName"
        :tab="item.tabName"
      >
        <router-view v-if="activeKey===item.routeName" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {
  name: 'CardServiceManagesShowTab',
  data() {
    return {
      activeKey: '',
      tabs: [
        { routeName: 'card_service_manages_unexpired', tabName: '服务周期即将到期' },
        { routeName: 'card_service_manages_expired', tabName: '服务周期已到期' }
      ]
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.activeKey = this.$route.name
      }
    }
  },
  created() {
    this.activeKey = this.$route.name
  },
  methods: {
    changeTab(activeKey) {
      this.activeKey = activeKey
      this.$router.push({ name: activeKey })
    }
  }
}
</script>
